import React from 'react'
import { TABLA_PROYECCION_EXPORTADOR } from '../../../config/tables'
import MuiTable from '../../Forms/SharedComponents/containers/MuiTable'

function ProyeccionExportador () {
  return (
    <MuiTable id={TABLA_PROYECCION_EXPORTADOR} />
  )
}

export default ProyeccionExportador
